import { render, staticRenderFns } from "./ModalNuevoRequisito.vue?vue&type=template&id=4861c4b8&"
import script from "./ModalNuevoRequisito.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoRequisito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports